import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.75 13.583a2.583 2.583 0 1 1 5.167 0 2.583 2.583 0 0 1-5.167 0M7.333 12.5a1.083 1.083 0 1 0 0 2.167 1.083 1.083 0 0 0 0-2.167M12.25 13.583a2.583 2.583 0 1 1 5.167 0 2.583 2.583 0 0 1-5.167 0m2.583-1.083a1.083 1.083 0 1 0 0 2.167 1.083 1.083 0 0 0 0-2.167",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.167 3.5a.75.75 0 0 1 .75-.75H11.2a1.3 1.3 0 0 1 1.3 1.3v10.283H9.212a.75.75 0 0 1 0-1.5H11V4.25H.917a.75.75 0 0 1-.75-.75M2.75 7.792a.75.75 0 0 1 .75.75v4.291h1.68a.75.75 0 0 1 0 1.5H3.3a1.3 1.3 0 0 1-1.3-1.3V8.542a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.084 6.25a.75.75 0 0 1 .75-.75H5.5a.75.75 0 1 1 0 1.5H1.834a.75.75 0 0 1-.75-.75M11 6.25a.75.75 0 0 1 .75-.75h5.143a1.3 1.3 0 0 1 1.188.772l1.64 3.692a1.3 1.3 0 0 1 .112.528v2.541a1.3 1.3 0 0 1-1.3 1.3h-1.741a.75.75 0 0 1 0-1.5h1.541v-2.299L16.763 7H11.75a.75.75 0 0 1-.75-.75M11 13.583a.75.75 0 0 1 .75-.75h.917a.75.75 0 0 1 0 1.5h-.917a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }